const dishesData = [
  {
    id: 1,
    name: "Creamy Pasta",
    image: "https://cdn.leonardo.ai/users/eea74984-fa00-4b1f-a893-228a092f4558/generations/96b19634-120d-43ca-a76d-3e37afef9643/segments/1:1:1/Flux_Dev_photography_of_Cinematic_editorialstyle_food_photo_ca_0.jpeg?w=512",
  },
  {
    id: 2,
    name: "Banana Pancakes",
    image: "https://cdn.leonardo.ai/users/eea74984-fa00-4b1f-a893-228a092f4558/generations/9fcded79-cccf-4821-8217-bb915b2a660c/segments/1:1:1/Flux_Dev_photography_of_Cinematic_editorialstyle_food_photo_ca_0.jpeg?w=512"
  },
  {
    id: 3,
    name: "Berry Charlotte",
    image: "https://cdn.leonardo.ai/users/eea74984-fa00-4b1f-a893-228a092f4558/generations/e3da120b-48b5-4d9d-83d3-627ef54d201f/Leonardo_Phoenix_10_Cinematic_editorialstyle_food_photo_captur_0.jpg?w=512"
  },
  {
    id: 4,
    name: "Pizza with Mushrooms",
    image: "https://cdn.leonardo.ai/users/eea74984-fa00-4b1f-a893-228a092f4558/generations/c8d04d70-4abd-40cc-bc5a-82c27851ce99/segments/1:1:1/Flux_Dev_photography_of_Cinematic_editorialstyle_food_photo_ca_0.jpeg?w=512"
  },
  {
    id: 5,
    name: "Sausage & Egg Protein Bowl",
    image: "https://cdn.leonardo.ai/users/eea74984-fa00-4b1f-a893-228a092f4558/generations/3f248a2d-7e6c-4b4d-a90d-3f7ca0e847d5/Leonardo_Phoenix_10_Cinematic_editorialstyle_food_photo_captur_0.jpg?w=512"
  },
  {
    id: 6,
    name: "French-Style Roast Beef",
    image: "https://cdn.leonardo.ai/users/eea74984-fa00-4b1f-a893-228a092f4558/generations/2ea49934-41e2-4512-82ca-d0c371b250a7/Leonardo_Phoenix_10_Cinematic_editorialstyle_food_photo_captur_0.jpg?w=512"
  },
  {
    id: 7,
    name:"Banana Smoothie Bowl",
    image: "https://cdn.leonardo.ai/users/eea74984-fa00-4b1f-a893-228a092f4558/generations/39c29312-4586-4ac5-a9ce-8572d4d032db/segments/1:1:1/Flux_Dev_photography_of_Cinematic_editorialstyle_food_photo_ca_0.jpeg?w=512"
  },
  {
    id: 8,
    name: "Chocolate Mousse",
    image: "https://cdn.leonardo.ai/users/eea74984-fa00-4b1f-a893-228a092f4558/generations/526404f3-99e2-4cb0-9dd0-d6c69be017f0/Leonardo_Phoenix_10_Cinematic_editorialstyle_food_photo_captur_0.jpg?w=512"
  },
  {
    id: 9,
    name: "Shrimp & Avocado Salad",
    image: "https://cdn.leonardo.ai/users/eea74984-fa00-4b1f-a893-228a092f4558/generations/6236cb7d-d881-4c00-a56d-08cdf52f29a3/Leonardo_Phoenix_10_A_cinematic_editorialstyle_food_photo_capt_1.jpg?w=512"
  },
  {
    id: 10,
    name: "Classic Margherita Pizza",
    image: " https://cdn.leonardo.ai/users/eea74984-fa00-4b1f-a893-228a092f4558/generations/f2095a89-d187-46fb-936f-6de51a6c1f31/Leonardo_Phoenix_10_Cinematic_editorialstyle_food_photo_captur_0.jpg?w=512"
  }
];

export default dishesData; 